var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabelWrapper',{attrs:{"label":_vm.label,"widelabel":_vm.widelabel,"smlabel":_vm.smlabel}},[_c('FText',{attrs:{"disabled":_vm.disabled,"value":_vm.stringValue},on:{"keydown":(v) => _vm.onKeydown(v),"input":(v) => _vm.onInput(v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }